module.exports = __webpack_public_path__ + "static/media/scre-7-bg.ee472f9e.png";